import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import {
  AutoAwesome as SparklesIcon,
  Schedule as ClockIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useSubscription } from '../contexts/SubscriptionContext';

const TrialExpiredPage: React.FC = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const { dismissTrialExpired } = useSubscription();

  const handleContinueWithFree = () => {
    dismissTrialExpired();
    navigate('/dashboard');
  };

  const handleViewPlans = () => {
    dismissTrialExpired();
    navigate('/pricing');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #FFF5F7 0%, #FFF8E1 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        pt: 'max(env(safe-area-inset-top), 16px)',
        pb: 'max(env(safe-area-inset-bottom), 16px)',
        pl: 'max(env(safe-area-inset-left), 16px)',
        pr: 'max(env(safe-area-inset-right), 16px)',
      }}
    >
      <Container maxWidth="sm">
        <Card
          elevation={3}
          sx={{
            borderRadius: theme.radii.large,
            backgroundColor: theme.colors.background,
            textAlign: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.colors.primary,
              py: 4,
              position: 'relative',
            }}
          >
            <img
              src="/hostly-02.png"
              alt="Logo decorativa"
              style={{
                position: "absolute",
                top: -20,
                left: -50,
                width: 150,
                opacity: 0.2,
              }}
            />
            <img
              src="/hostly-02.png"
              alt="Logo decorativa"
              style={{
                position: "absolute",
                bottom: -20,
                right: -50,
                width: 150,
                opacity: 0.2,
              }}
            />

            <Box sx={{ position: 'relative', zIndex: 2 }}>
              <ClockIcon sx={{ fontSize: 64, color: 'white', mb: 2 }} />
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: 'white',
                }}
              >
                Período de Teste Encerrado
              </Typography>
            </Box>
          </Box>

          <CardContent sx={{ p: 4 }}>
            <Typography
              variant="body1"
              sx={{
                color: theme.colors.text.primary,
                mb: 3,
                fontSize: '1.1rem',
              }}
            >
              Seus 30 dias de teste gratuito do plano <strong>Basic</strong> chegaram ao fim!
            </Typography>

            <Typography
              variant="body2"
              sx={{
                color: theme.colors.text.secondary,
                mb: 4,
              }}
            >
              Agora você pode escolher entre continuar com o plano gratuito ou assinar um de nossos planos pagos para aproveitar todos os recursos do Hostly.
            </Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button
                variant="contained"
                size="large"
                onClick={handleViewPlans}
                startIcon={<SparklesIcon />}
                sx={{
                  backgroundColor: theme.colors.secondary,
                  color: 'white',
                  fontWeight: 700,
                  borderRadius: theme.radii.medium,
                  py: 1.5,
                  boxShadow: 3,
                  '&:hover': {
                    backgroundColor: theme.colors.secondary,
                    opacity: 0.9,
                  },
                }}
              >
                Ver Planos e Assinar
              </Button>

              <Button
                variant="outlined"
                size="large"
                onClick={handleContinueWithFree}
                sx={{
                  borderColor: theme.colors.text.secondary,
                  color: theme.colors.text.secondary,
                  fontWeight: 600,
                  borderRadius: theme.radii.medium,
                  py: 1.5,
                  '&:hover': {
                    borderColor: theme.colors.text.primary,
                    backgroundColor: 'transparent',
                  },
                }}
              >
                Continuar com Plano Gratuito
              </Button>
            </Box>

            <Typography
              variant="caption"
              sx={{
                color: theme.colors.text.secondary,
                mt: 3,
                display: 'block',
              }}
            >
              Você pode alterar seu plano a qualquer momento nas configurações
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default TrialExpiredPage;
